import { ReactNode } from "react";
import { Icon, IconName } from "./Icon";

type Props = {
  icon?: IconName;
  iconBg?: string;
  iconFg?: string;
  label: ReactNode;
  sub?: ReactNode;
  right?: ReactNode;
  danger?: boolean;
  last?: boolean;
  onClick?: () => void;
};

export function Row({ icon, iconBg = "#EEF2FF", iconFg = "#1B3A8C", label, sub, right, danger, last, onClick }: Props) {
  const clickable = !!onClick;
  return (
    <div
      onClick={onClick}
      style={{
        display: "flex",
        alignItems: "center",
        gap: 12,
        padding: "12px 14px",
        borderBottom: last ? "none" : "1px solid var(--tcg-border)",
        cursor: clickable ? "pointer" : "default",
      }}
    >
      {icon && (
        <div
          style={{
            width: 30,
            height: 30,
            borderRadius: 8,
            background: iconBg,
            color: iconFg,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexShrink: 0,
          }}
        >
          <Icon name={icon} size={15} />
        </div>
      )}
      <div style={{ flex: 1, minWidth: 0 }}>
        <div
          style={{
            fontSize: 13,
            fontWeight: 700,
            color: danger ? "var(--tcg-danger)" : "var(--tcg-ink)",
            lineHeight: 1.3,
          }}
        >
          {label}
        </div>
        {sub && (
          <div style={{ fontSize: 10.5, color: "var(--tcg-muted)", fontWeight: 600, marginTop: 2, lineHeight: 1.35 }}>
            {sub}
          </div>
        )}
      </div>
      <div style={{ flexShrink: 0, color: "var(--tcg-muted-soft)", display: "flex", alignItems: "center", gap: 6 }}>
        {right}
      </div>
    </div>
  );
}
